import { render, staticRenderFns } from "./DefaultHome.vue?vue&type=template&id=53a919d9&scoped=true&"
import script from "./DefaultHome.vue?vue&type=script&lang=js&"
export * from "./DefaultHome.vue?vue&type=script&lang=js&"
import style0 from "./DefaultHome.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DefaultHome.vue?vue&type=style&index=1&id=53a919d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a919d9",
  null
  
)

export default component.exports